import * as React from "react"
import { Helmet } from "react-helmet"

import Footer from "../components/footer.js"
import Header from "../components/header.js"

import Favicon from "../images/bordr-favicon.png"

const Wishlist =  () => {
    return (
        <main>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="shortcut icon" type="image/png" href={Favicon}/>
                <meta name="author" content="Bordr Team"></meta>
                <meta name="description" content="What should Bordr offer next?"></meta>
                {/* Open graph data */}
                <meta property="og:title" content="Bordr - Wishlist"/>
                <meta property="og:description" content="What should Bordr offer next?" />
                <title>Bordr - Wishlist</title>        
                {/* paperform */}
                <script type="text/javascript" async defer>{'(function() {var script = document.createElement("script"); script.src = "https://paperform.co/__embed"; document.body.appendChild(script); })()'}</script>
                {/* iubenda popups */}
                <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
                {/* helpscout beacon */}
                <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
                <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
            </Helmet>
            <section className="bg-gray-50 pb-12">
                <Header />
                <iframe className="airtable-embed h-screen" src="https://airtable.com/embed/shr9im94woxGh4W0N?backgroundColor=purple" frameborder="0" onmousewheel="" width="100%" height="533" ></iframe>                
                {/* style="background: transparent; border: 1px solid #ccc;" */}
            </section>
            <Footer />
        </main>         
    )    
}
export default Wishlist

// import * as React from "react"
// import { Helmet } from "react-helmet"

// import Footer from "../components/footer.js"
// import Header from "../components/header.js"

// import EmailConfirmation from "../images/email-confirmation.svg"
// import Favicon from "../images/bordr-favicon.png"

// const AboutPage =  () => {
//     return (
//         <main>
//             <Helmet>
//             <meta charSet="utf-8" />
//                 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//                 <meta name="robots" content="noindex"></meta>
//                 <link rel="shortcut icon" type="image/png" href={Favicon}/>
//                 <meta name="author" content="Bordr Team"></meta>
//                 <meta name="description" content="Thank you for placing your order with Bordr!"></meta>
//                 {/* Open graph data */}
//                 <meta property="og:title" content="Bordr - Thank You" />
//                 <meta property="og:description" content="Thank you for placing your order with Bordr!" />
//                 <title>Bordr - Thank You</title>       
//                 {/* iubenda popups */}
//                 <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
//                 <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
//                 {/* helpscout beacon */}
//                 <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
//                 <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
//             </Helmet>
//             <section className="bg-gray-50 pb-24">
//                 <Header />
//                 <div className="max-w-screen-xl mx-auto px-6 w-full md:w-2/3">
//                     <div className="pt-16 mb-8 md:mb-10 text-center">
//                         <h1 className="text-4xl md:text-5xl font-bold">Thank you for placing your order with Bordr!</h1>
//                         <p className="text-lg md:text-xl mt-4">Please check your email for next steps.</p>
//                         <img src={EmailConfirmation} alt="email confirmation icon"className="w-20 md:w-24 mt-8 mx-auto"/>
//                     </div>
//                 </div>
//                 <iframe className="airtable-embed h-96" src="https://airtable.com/embed/shr9im94woxGh4W0N?backgroundColor=purple" frameborder="0" onmousewheel="" width="100%" height="533" ></iframe>                
//                 {/* style="background: transparent; border: 1px solid #ccc;" */}
//             </section>
//             <Footer />
//         </main>         
//     )    
// }
// export default AboutPage